export const PREDICT_DISEASE_SUCCESS = 'PREDICT_DISEASE_SUCCESS'
export const PREDICT_DISEASE_FAIL = 'PREDICT_DISEASE_FAIL'
export const PREDICT_DISEASE_CLEAR_DATA = 'PREDICT_DISEASE_CLEAR_DATA'
